import useShareSecret from '../post/useShareSecret';
import useSlug from '../utils/router/useSlug';
import useIsPublicView from '../utils/useIsPublicView';

const useIsPublicDocumentationView = (): boolean => {
  const [postId] = useSlug('postSlug');
  const shareSecret = useShareSecret();
  const isPublicView = useIsPublicView();

  if (!isPublicView || !window.__slab.PUBLIC_ORG.settings.public) return false;
  if (postId) return !shareSecret;

  return true;
};

export default useIsPublicDocumentationView;
